import axios from "axios";
import { Get, Post, Put, Delete } from "../server";

//  创建站点
export function createSubstations(data: any) {
    return Post("/admin/substation/substation", data);
}

// 获取 
export function getSubstations(data: any) {
    return Get("/admin/substation/substations", data);
}

/**
 * @param Put(url, headers, data) url 请求地址 headers 自定义头部 data 参数
 **/

// 修改
export function updateSubstations(substationId: any, data: any) {
    return axios({
        url: `/admin/substation/substation/${substationId}`,
        method: "put",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
        data,
        baseURL: process.env.REACT_APP_BASE_URL,
    });
}

// 子站模块
export function substationModule(substationId: string) {
    return Get(`/admin/substation/${substationId}/modules`)
}